// components/copilot/utils/format.js
export const fmtMoney = (usd) => {
  if (usd == null || Number.isNaN(Number(usd))) return "—";
  return `$${Number(usd).toFixed(4)}`;
};

export const fmtTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString();
};
